import axios from "axios";
import router from "../router";
import store from "../store"
import i18n from "../i18n"
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
const setHeaders = () => {
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.common["Accept-Language"] = i18n.locale || "en";
  if (localStorage.getItem("token")) {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Token ${localStorage.getItem("token")}`;
  }
  if(localStorage.getItem("userSelectedCompany")){
    axios.defaults.headers.common[
      "Company-Id"
    ] = store.state.user.userCompany ? store.state.user.userCompany : localStorage.getItem("userSelectedCompany");
  }
};

export const getReq = async (enpoint, company = null) => {
  setHeaders();
  if (company) {
    axios.defaults.headers.common[
      "Company-Id"
    ] = company;
  }
  return await axios
    .get(`${enpoint}`)
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      if (error.response && (error.response.status == 401 || error.response.status == 403)) {
        localStorage.clear()
        delete axios.defaults.headers.common["Authorization"];
        router.push('/login')
      }
      throw error;
    });
};

// Same as getReq but keeps the raw response — file downloads need the blob body
// plus the headers (content type / filename).
export const getBlobReq = async (enpoint) => {
  setHeaders();
  return await axios
    .get(`${enpoint}`, { responseType: "blob" })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.response && (error.response.status == 401 || error.response.status == 403)) {
        localStorage.clear()
        delete axios.defaults.headers.common["Authorization"];
        router.push('/login')
      }
      throw error;
    });
};

export const getById = async (enpoint, id) => {
  setHeaders();
  return await axios
    .get(`${enpoint}${id}/`)
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      if (error.response && (error.response.status == 401 || error.response.status == 403)) {
        localStorage.clear()
        delete axios.defaults.headers.common["Authorization"];
        router.push('/login')
      }
      throw error;
    });
};

export const postReq = async (enpoint, payload, key = null) => {
  setHeaders();
  if (key) {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Token ${key}`;
  }
  if(!localStorage.getItem("userSelectedCompany")){
    axios.defaults.headers.common[
      "Company-Id"
    ] = payload.company
  }
  return await axios
    .post(`${enpoint}`, payload instanceof FormData ? payload : { ...payload, ...localStorage.getItem("userSelectedCompany") ? { company_id: payload.company_id ? payload.company_id : parseInt(store.state.user.userCompany ? store.state.user.userCompany : localStorage.getItem("userSelectedCompany")) } : {} })
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      if (error.response && (error.response.status == 401 || error.response.status == 403)) {
        localStorage.clear()
        delete axios.defaults.headers.common["Authorization"];
        router.push('/login')
      }
      throw error;
    });
};


export const putReq = async (enpoint, id, payload) => {
  setHeaders();
  return await axios
    .put(`${enpoint}/${id}`, payload instanceof FormData ? payload : { ...payload, ...localStorage.getItem("userSelectedCompany") ? { company_id: parseInt(store.state.user.userCompany ? store.state.user.userCompany : localStorage.getItem("userSelectedCompany")) } : {} })
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      if (error.response && (error.response.status == 401 || error.response.status == 403)) {
        localStorage.clear()
        delete axios.defaults.headers.common["Authorization"];
        router.push('/login')
      }
      throw error;
    });
};
export const patchReq = async (enpoint, id=null, payload, key = null, addCompany= true) => {
  setHeaders();
  if (key) {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Token ${key}`;
  }
  return await axios
    .patch(`${enpoint}/${id ? `${id}/` : ''}${addCompany ? `?company_id=${key ? id : parseInt(store.state.user.userCompany ? store.state.user.userCompany : localStorage.getItem("userSelectedCompany"))}`: ''}`, payload instanceof FormData ? payload : { ...payload, ...localStorage.getItem("userSelectedCompany") ? { company_id: parseInt(store.state.user.userCompany ? store.state.user.userCompany : localStorage.getItem("userSelectedCompany")) } : {} })
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      if (error.response && (error.response.status == 401 || error.response.status == 403)) {
        localStorage.clear()
        delete axios.defaults.headers.common["Authorization"];
        router.push('/login')
      }
      throw error;
    });
};

export const postFormData = async (enpoint, formData) => {
  setHeaders();
  axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
  // axios.defaults.headers.post["Content-Type"] = "'application/x-www-form-urlencoded; charset=UTF-8'";
  return await axios
    .post(`${enpoint}`, formData)
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      if (error.response && (error.response.status == 401 || error.response.status == 403)) {
        localStorage.clear()
        delete axios.defaults.headers.common["Authorization"];
        router.push('/login')
      }
      throw error;
    });
};

export const deleteReq = async (enpoint, id) => {
  setHeaders();
  return await axios
    .delete(`${enpoint}/${id}`)
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      if (error.response && (error.response.status == 401 || error.response.status == 403)) {
        localStorage.clear()
        delete axios.defaults.headers.common["Authorization"];
        router.push('/login')
      }
      throw error;
    });
};

export const postStreamReq = async (enpoint, data, onEvent) => {
  const headers = {
    "Content-Type": "application/json;charset=utf-8",
    "Accept-Language": i18n.locale || "en",
  };
  if (localStorage.getItem("token")) {
    headers["Authorization"] = `Token ${localStorage.getItem("token")}`;
  }
  if (localStorage.getItem("userSelectedCompany")) {
    headers["Company-Id"] = store.state.user.userCompany
      ? store.state.user.userCompany
      : localStorage.getItem("userSelectedCompany");
  }
  const response = await fetch(`${process.env.VUE_APP_API_URL}${enpoint}`, {
    method: "POST",
    headers,
    body: JSON.stringify(data),
  });
  if (response.status === 401 || response.status === 403) {
    localStorage.clear();
    delete axios.defaults.headers.common["Authorization"];
    router.push("/login");
    throw { data: { error: i18n.t("aiChat.errorResponse") } };
  }
  if (!response.ok || !response.body) {
    // A failure comes back as one ordinary JSON body, not as a stream.
    const failure = await response.json().catch(() => null);
    throw { data: failure || {} };
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  // A chunk can split a line in half, so only whole lines are handed over.
  const drain = (flush) => {
    const lines = buffer.split("\n");
    buffer = flush ? "" : lines.pop();
    lines.forEach((line) => {
      const text = line.replace(/^data:\s*/, "").trim();
      if (!text) return;
      try {
        onEvent(JSON.parse(text));
      } catch (error) {
        console.error("Failed to parse stream event:", text);
      }
    });
  };
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    drain(false);
  }
  buffer += decoder.decode();
  drain(true);
};
